import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { USERTYPE_LIST, USERTYPE_CHANGE_STATUS, USERTYPE_ADDEDIT, USERTYPE_DELETE } from "../../api/constApi";
import { UserTypeListApi, UserTypeChangeStatusApi, AddEditUserTypeApi, DeleteUserTypeApi } from "../Services/userTypeService";
import { useSelector } from "react-redux";
import { useMemo } from "react";

export const userTypeList = createAsyncThunk(USERTYPE_LIST, async (payload) => {
    const response = await UserTypeListApi(payload);
    return response.data;
});

export const userTypeChangeStatus = createAsyncThunk(USERTYPE_CHANGE_STATUS, async (payload) => {
    const response = await UserTypeChangeStatusApi(payload);
    return response.data;
});

export const addEditUserType = createAsyncThunk(USERTYPE_ADDEDIT, async (payload) => {
    const response = await AddEditUserTypeApi(payload);
    return response.data;
});

export const deleteUserType = createAsyncThunk(USERTYPE_DELETE, async (payload) => {
    const response = await DeleteUserTypeApi(payload);
    return response.data;
});



export const userTypeSlice = createSlice({
    name: "userType",
    initialState: {
        userType: null,
        token: null,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(userTypeList.fulfilled, (state, action) => {
            state.userType = action?.payload;
        });
        builder.addCase(addEditUserType.fulfilled, (state, action) => {
            state.userType = action?.payload?.Data;
          });
    }
});

export default userTypeSlice.reducer;

// villagelist selector
export const selectUserTypeList = (state) => state?.userType?.userType;
export const useUserTypeList = () => {
  const userType = useSelector(selectUserTypeList);
  return useMemo(() => userType, [userType]);
};